import type { FC } from 'react';

import { VideoCameraIcon } from '@heroicons/react/24/outline';

import type { VideoUploadLimits } from '@/types';
import { formatVideoLimits } from '@/video/formatVideoLimits';

import { tr } from './constants';

// Shared drop-target overlay for both the composer editor area and the video popover.
// Absolute, so its parent must be positioned relative. It intentionally captures pointer
// events: a click-through overlay would let the drag reach the editor underneath, which
// then draws its own drop-cursor line.
export const VideoDropOverlay: FC<{
  translations?: Record<string, string>;
  limits: VideoUploadLimits;
  locale?: string;
}> = ({ translations, limits, locale }) => {
  const { size, duration } = formatVideoLimits(limits, locale);

  return (
    <div className="absolute inset-0 z-[60] flex flex-col items-center justify-center gap-2 rounded-3xl border-2 border-dashed border-black/30 bg-white/90 p-6 text-center">
      <VideoCameraIcon className="size-8 text-black/60" aria-hidden="true" />
      <p className="text-sm font-medium text-black/70">{tr(translations, 'community.composer.add_video')}</p>
      <p className="text-xs text-black/50">
        {tr(translations, 'video.hint').replace('{{size}}', size).replace('{{duration}}', duration)}
      </p>
    </div>
  );
};
